export const QUERY_PARAM_SEARCH_TERM = 'q'
export const SUGGESTION_DROPDOWN_ID = 'cmp-saas-suggestions'
export const SEARCH_INPUT_CLASS = 'cmp-saas__search-input'
export const SAAS_CONTAINER_FORM_SUGGESTIONS_SELECTOR = `.cmp-saas__form #${SUGGESTION_DROPDOWN_ID}`
export const SUGGESTION_ELEMENT_CLASS = 'cmp-saas__suggestion-element'
export const ACTIVE_SUGGESTION_ELEMENT_CLASS = `${SUGGESTION_ELEMENT_CLASS}--active`
export const CMP_SAAS_RESULTS_CLASS = 'cmp-saas__results'
export const STORAGE_SUGGESTIONS_KEY = '__saas__suggestions__'
export const STORAGE_QUERY_STRING_KEY = '__saas__queryString__'
